module.exports = __webpack_public_path__ + "img/face60.56d2cd25.gif";